import { merchantApi } from "@api";
import { enumLanguage } from "@configs";
import { IInfo, IMerchant } from "@interfaces";
import { store } from "@redux";
import UserStore from "@Rocket-Innovation/components/store/UserStore";
import { Carousel } from "antd";
import { useState } from "react";
import { useHistory } from "react-router";
import { formatDateNumber } from "src/Utils/dateUtil";
import styled from "styled-components";
import { Readmore } from "../shared/Readmore";

interface LayoutClickBoxProps {
    merchant: IMerchant | null;
    userInfo: IInfo | null;
    themeColor: string;
}

export default function LayoutClickBox({ merchant, userInfo, themeColor }: LayoutClickBoxProps) {
    const [showNews, setShowNews] = useState<boolean>(false);
    const history = useHistory();
    const token = UserStore.getState().accessToken ?? store.getState().auth.auth?.accessToken;
    const [newsList, setNewsList] = useState<any[]>([]);
    const [isClicked, setIsClicked] = useState(false);
    const [showTextLeft, setShowTextLeft] = useState<boolean>(false);
    const [showTextRight, setShowTextRight] = useState<boolean>(false);
    const i18nextLng = window.localStorage.i18nextLng;
    const handleClickRead = () => {
        setIsClicked(!isClicked);
    };

    // useEffect(() => {
    //     if (token) {
    //         findNewsList();
    //     }
    // }, [token]);

    const findNewsList = async () => {
        let res = await merchantApi.getNewsList();
        setNewsList(res.data.docs);
    };

    const handleClickBottomMenu = (path: string) => {
        if (path[0] === "/") {
            history.push(path);
        } else if (path.includes("pos-client") || path.includes("service-client")) {
            window.open(`${path}/auth/${token}`, "_self");
        } else if (path.includes("rocket-booking") || path.includes("eventease")) {
            let outUrl = path.split("/booking")[0];
            window.open(`${outUrl}/auth/${token}?redirect=booking`, "_self");
        } else {
            window.open(path, "_self");
        }
    };
    const newsSlide = (currentSlide: number) => {
        //
    };

    // console.log("test left", merchant?.themes?.featureLeft);
    // console.log("test right", merchant?.themes?.featureRight);

    const ClientLeft = () => {
        return (
            <StyledClickBox>
                <div className="layout-click-box line">
                    <div
                        className="action-click"
                        onClick={() => {
                            merchant?.themes?.featureLeft === "News"
                                ? (setShowNews(true), findNewsList())
                                : handleClickBottomMenu(merchant?.themes?.menuLeftLink!);
                        }}
                    >
                        <div className="layout-box-bg">
                            <img src={merchant?.themes?.iconLeft} alt="" />
                        </div>
                        <div className="layout-box-text">
                            <span>
                                {i18nextLng === enumLanguage.EN || i18nextLng === enumLanguage.EN_GB
                                    ? merchant?.themes?.menuLeft
                                    : merchant?.themes?.menuLeftTh}
                            </span>
                            {merchant?.themes?.featureLeft !== "Gift card" &&
                            merchant?.themes?.featureLeft !== "Member card" ? (
                                <span className="subtext">
                                    {i18nextLng === enumLanguage.EN ||
                                    i18nextLng === enumLanguage.EN_GB
                                        ? merchant?.themes?.descriptLeft
                                        : merchant?.themes?.descriptLeftTh}
                                </span>
                            ) : null}
                            {merchant?.themes?.featureLeft === "Gift card" ? (
                                <span className="subtext">
                                    {userInfo?.totalCardCashNotAllMember &&
                                    userInfo?.totalCardCashNotAllMember !== 0
                                        ? new Intl.NumberFormat().format(
                                              parseInt(userInfo?.totalCardCashNotAllMember || "0")
                                          ) +
                                          " " +
                                          " THB"
                                        : "View"}
                                </span>
                            ) : // <span className="subtext">{userInfo?.totalCardCashNotAllMember} THB</span>
                            null}
                            {merchant?.themes?.featureLeft === "Member card" ? (
                                <span className="subtext">
                                    {userInfo?.totalCardCashAllMember !== 0 &&
                                    userInfo?.totalCardCashAllMember !== undefined
                                        ? new Intl.NumberFormat().format(
                                              parseInt(userInfo?.totalCardCashAllMember || "0")
                                          ) +
                                          " " +
                                          " THB"
                                        : "View"}{" "}
                                </span>
                            ) : // <span className="subtext">{userInfo?.totalCardCashAllMember} THB</span>
                            null}
                        </div>
                    </div>

                    {merchant?.themes?.informationLeft === "" ? null : (
                        <div
                            className="information"
                            onClick={() => {
                                setShowTextLeft(true);
                            }}
                        >
                            <img src="../images/ic-information.png" alt="" />
                        </div>
                    )}
                </div>
            </StyledClickBox>
        );
    };

    const ClientRight = () => {
        return (
            <StyledClickBox>
                <div className="layout-click-box">
                    <div
                        className="action-click"
                        onClick={() =>
                            merchant?.themes?.featureRight === "News"
                                ? setShowNews(true)
                                : handleClickBottomMenu(merchant?.themes?.menuRightLink!)
                        }
                    >
                        <div className="layout-box-bg">
                            <img src={merchant?.themes?.iconRight} alt="" />
                        </div>
                        <div className="layout-box-text">
                            <span>
                                {i18nextLng === enumLanguage.EN || i18nextLng === enumLanguage.EN_GB
                                    ? merchant?.themes?.menuRight
                                    : merchant?.themes?.menuRightTh}
                            </span>
                            {merchant?.themes?.featureRight !== "Gift card" &&
                                merchant?.themes?.featureRight !== "Member card" && (
                                    <span className="subtext">
                                        {i18nextLng === enumLanguage.EN ||
                                        i18nextLng === enumLanguage.EN_GB
                                            ? merchant?.themes?.descriptRight
                                            : merchant?.themes?.descriptRightTh}
                                    </span>
                                )}
                            {merchant?.themes?.featureRight === "Gift card" ? (
                                <span className="subtext">
                                    {userInfo?.totalCardCashNotAllMember &&
                                    userInfo?.totalCardCashNotAllMember !== 0
                                        ? new Intl.NumberFormat().format(
                                              parseInt(userInfo?.totalCardCashNotAllMember || "0")
                                          ) +
                                          " " +
                                          " THB"
                                        : "View"}
                                </span>
                            ) : // <span className="subtext">{userInfo?.totalCardCashNotAllMember} THB</span>
                            null}
                            {merchant?.themes?.featureRight === "Member card" ? (
                                <span className="subtext">
                                    {userInfo?.totalCardCashAllMember !== 0 &&
                                    userInfo?.totalCardCashAllMember !== undefined
                                        ? new Intl.NumberFormat().format(
                                              parseInt(userInfo?.totalCardCashAllMember || "0")
                                          ) +
                                          " " +
                                          " THB"
                                        : "View"}{" "}
                                </span>
                            ) : // <span className="subtext">{userInfo?.totalCardCashAllMember} THB</span>
                            null}
                        </div>
                    </div>

                    {merchant?.themes?.informationRight === "" ? null : (
                        <div
                            className="information"
                            onClick={() => {
                                setShowTextRight(true);
                            }}
                        >
                            <img src="../images/ic-information.png" alt="" />
                        </div>
                    )}
                </div>
            </StyledClickBox>
        );
    };

    const SellerLeft = () => {
        return (
            <StyledClickBox>
                <div className="layout-click-box line">
                    <div
                        className="action-click"
                        onClick={() =>
                            merchant?.themes?.sellerThemeSetting?.highlightMenu?.featureLeft ===
                            "News"
                                ? setShowNews(true)
                                : handleClickBottomMenu(
                                      merchant?.themes?.sellerThemeSetting?.highlightMenu
                                          ?.menuLeftLink!
                                  )
                        }
                    >
                        <div className="layout-box-bg">
                            <img
                                src={merchant?.themes?.sellerThemeSetting?.highlightMenu?.iconLeft}
                                alt=""
                            />
                        </div>
                        <div className="layout-box-text">
                            <span>
                                {merchant?.themes?.sellerThemeSetting?.highlightMenu?.menuLeft}
                            </span>
                            {merchant?.themes?.sellerThemeSetting?.highlightMenu?.featureLeft !==
                                "Gift card" &&
                            merchant?.themes?.sellerThemeSetting?.highlightMenu?.featureLeft !==
                                "Member card" ? (
                                <span className="subtext">
                                    {
                                        merchant?.themes?.sellerThemeSetting?.highlightMenu
                                            ?.descriptLeft
                                    }
                                </span>
                            ) : null}
                            {merchant?.themes?.sellerThemeSetting?.highlightMenu?.featureLeft ===
                            "Gift card" ? (
                                <span className="subtext">
                                    {userInfo?.totalCardCashNotAllMember &&
                                    userInfo?.totalCardCashNotAllMember !== 0
                                        ? new Intl.NumberFormat().format(
                                              parseInt(userInfo?.totalCardCashNotAllMember || "0")
                                          ) +
                                          " " +
                                          " THB"
                                        : "View"}
                                </span>
                            ) : // <span className="subtext">{userInfo?.totalCardCashNotAllMember} THB</span>
                            null}
                            {merchant?.themes?.sellerThemeSetting?.highlightMenu?.featureLeft ===
                            "Member card" ? (
                                <span className="subtext">
                                    {userInfo?.totalCardCashAllMember !== 0
                                        ? new Intl.NumberFormat().format(
                                              parseInt(userInfo?.totalCardCashAllMember || "0")
                                          ) +
                                          " " +
                                          " THB"
                                        : "View"}{" "}
                                </span>
                            ) : // <span className="subtext">{userInfo?.totalCardCashAllMember} THB</span>
                            null}
                        </div>
                    </div>

                    {/* {merchant?.themes?.sellerThemeSetting?.highlightMenu?.informationLeft ===
                    "" ? null : (
                        <div
                            className="information"
                            onClick={() => {
                                setShowTextLeft(true);
                            }}
                        >
                            <img src="../images/ic-information.png" alt="" />
                        </div>
                    )} */}
                </div>
            </StyledClickBox>
        );
    };

    const SellerRight = () => {
        return (
            <StyledClickBox>
                <div className="layout-click-box">
                    <div
                        className="action-click"
                        onClick={() =>
                            merchant?.themes?.sellerThemeSetting?.highlightMenu?.featureRight ===
                            "News"
                                ? setShowNews(true)
                                : handleClickBottomMenu(
                                      merchant?.themes?.sellerThemeSetting?.highlightMenu
                                          ?.menuRightLink!
                                  )
                        }
                    >
                        <div className="layout-box-bg">
                            <img
                                src={merchant?.themes?.sellerThemeSetting?.highlightMenu?.iconRight}
                                alt=""
                            />
                        </div>
                        <div className="layout-box-text">
                            <span>
                                {merchant?.themes?.sellerThemeSetting?.highlightMenu?.menuRight}
                            </span>
                            {merchant?.themes?.sellerThemeSetting?.highlightMenu?.featureRight !==
                                "Gift card" &&
                            merchant?.themes?.sellerThemeSetting?.highlightMenu?.featureRight !==
                                "Member card" ? (
                                <span className="subtext">
                                    {
                                        merchant?.themes?.sellerThemeSetting?.highlightMenu
                                            ?.descriptRight
                                    }
                                </span>
                            ) : null}
                            {merchant?.themes?.sellerThemeSetting?.highlightMenu?.featureRight ===
                            "Gift card" ? (
                                <span className="subtext">
                                    {userInfo?.totalCardCashNotAllMember &&
                                    userInfo?.totalCardCashNotAllMember !== 0
                                        ? new Intl.NumberFormat().format(
                                              parseInt(userInfo?.totalCardCashNotAllMember || "0")
                                          ) +
                                          " " +
                                          " THB"
                                        : "View"}
                                </span>
                            ) : // <span className="subtext">{userInfo?.totalCardCashNotAllMember} THB</span>
                            null}
                            {merchant?.themes?.sellerThemeSetting?.highlightMenu?.featureRight ===
                            "Member card" ? (
                                <span className="subtext">
                                    {userInfo?.totalCardCashAllMember !== 0
                                        ? new Intl.NumberFormat().format(
                                              parseInt(userInfo?.totalCardCashAllMember || "0")
                                          ) +
                                          " " +
                                          " THB"
                                        : "View"}{" "}
                                </span>
                            ) : // <span className="subtext">{userInfo?.totalCardCashAllMember} THB</span>
                            null}
                        </div>
                    </div>

                    {merchant?.themes?.sellerThemeSetting?.highlightMenu?.informationRight ===
                    "" ? null : (
                        <div
                            className="information"
                            onClick={() => {
                                setShowTextRight(true);
                            }}
                        >
                            <img src="../images/ic-information.png" alt="" />
                        </div>
                    )}
                </div>
            </StyledClickBox>
        );
    };

    const TextLeft = () => {
        return (
            <StlyedInformation themeColor={themeColor}>
                <div className="control-show-text">{merchant?.themes?.informationLeft}</div>
                <div
                    className="close-popupinvite"
                    onClick={() => {
                        setShowTextLeft(false);
                    }}
                >
                    <img src="../images/ic-close-invite.svg" alt="" />
                </div>
            </StlyedInformation>
        );
    };

    const TextRight = () => {
        return (
            <StlyedInformation themeColor={themeColor}>
                <div className="control-show-text">{merchant?.themes?.informationRight}</div>
                <div
                    className="close-popupinvite"
                    onClick={() => {
                        setShowTextRight(false);
                    }}
                >
                    <img src="../images/ic-close-invite.svg" alt="" />
                </div>
            </StlyedInformation>
        );
    };

    const News = () => {
        return (
            <>
                {newsList?.length > 0 && (
                    <StyledNews themeColor={themeColor}>
                        <div className="wrapper-popup-news">
                            <Carousel afterChange={newsSlide} waitForAnimate={true}>
                                {newsList?.map((itemNews: any, index: any) => {
                                    if (itemNews.isActivate) {
                                        return (
                                            <div key={index}>
                                                <div className="control-popup-news">
                                                    <div className="img-popup-news">
                                                        <img src={itemNews?.imageUrl[0]} alt="" />
                                                    </div>
                                                    <Readmore
                                                        headText={itemNews?.headText}
                                                        createdAt={formatDateNumber(
                                                            itemNews?.createdAt
                                                        )}
                                                        descriptionText={itemNews?.discriptionText}
                                                        themeColor={themeColor}
                                                        onClick={() =>
                                                            console.log("Readmore clicked")
                                                        }
                                                    />
                                                </div>
                                            </div>
                                        );
                                    }
                                })}
                            </Carousel>
                        </div>
                        <div
                            className="close-popupinvite"
                            onClick={() => {
                                setShowNews(false);
                            }}
                        >
                            <img src="../images/ic-close-invite.svg" alt="" />
                        </div>
                    </StyledNews>
                )}
            </>
        );
    };

    {
        showTextLeft ? (
            <StlyedInformation themeColor={themeColor}>
                <div className="control-show-text">{merchant?.themes?.informationLeft}</div>
                <div
                    className="close-popupinvite"
                    onClick={() => {
                        setShowTextLeft(false);
                    }}
                >
                    <img src="../images/ic-close-invite.svg" alt="" />
                </div>
            </StlyedInformation>
        ) : null;
    }
    {
        showTextRight ? (
            <StlyedInformation themeColor={themeColor}>
                <div className="control-show-text">{merchant?.themes?.informationRight}</div>
                <div
                    className="close-popupinvite"
                    onClick={() => {
                        setShowTextRight(false);
                    }}
                >
                    <img src="../images/ic-close-invite.svg" alt="" />
                </div>
            </StlyedInformation>
        ) : null;
    }

    return (
        <>
            {!userInfo ? (
                <>
                    {merchant?.themes?.featureLeft && <ClientLeft />}
                    {merchant?.themes?.featureRight && <ClientRight />}
                </>
            ) : (
                <>
                    {merchant?.themes?.featureLeft &&
                        (userInfo?.contact?.sellerId === "" ||
                            userInfo?.contact?.sellerId === undefined) && <ClientLeft />}
                    {merchant?.themes?.featureRight &&
                        (userInfo?.contact?.sellerId === "" ||
                            userInfo?.contact?.sellerId === undefined) && <ClientRight />}
                    {/* {userInfo?.contact?.sellerId && <SellerLeft />}
                    {userInfo?.contact?.sellerId && <SellerRight />} */}
                </>
            )}

            {showTextLeft && <TextLeft />}
            {showTextRight && <TextRight />}
            {showNews && <News />}
        </>
    );
}

//#region Style

const StlyedInformation = styled.div<{ themeColor: string }>`
    height: 100vh;
    width: 100%;
    position: fixed;
    top: 0;
    left: 0;
    z-index: 10;
    display: flex;
    align-items: center;
    justify-content: center;
    max-width: 480px;
    background: rgba(0, 0, 0, 0.5);
    flex-direction: column;
    padding: 20px;
    .control-show-text {
        background-color: #fff;
        padding: 16px;
        border-radius: 16px;
        line-height: 19px;
        img {
            width: 100%;
        }
    }
    .close-popupinvite {
        position: relative;
        margin-top: 30px;
        z-index: 5;
        img {
            width: 32px;
        }
    }
`;

const StyledClickBox = styled.div`
    padding: 0 16px;
    @media (max-width: 400px) {
        padding: 0 8px;
    }
    .information {
        // position: absolute!important;
        right: -10px;
        top: 0;
        z-index: 2;
        img {
            width: 10px;
        }
    }
    .layout-click-box {
        position: relative;
        padding-right: 15px;
        display: flex;
        gap: 12px;
        justify-content: space-between;
        .action-click {
            display: flex;
            gap: 12px;
        }
    }
    .line {
        &:after {
            content: "";
            width: 1px;
            height: 100%;
            background-color: #e1e1e1;
            position: absolute;
            right: -8px;
            top: 50%;
            transform: translateY(-50%);
            @media (max-width: 400px) {
                right: -4px;
            }
        }
    }
    .layout-box-bg {
        position: relative;
        z-index: 1;
        img {
            width: 40px;
            opacity: 1;
            @media (max-width: 400px) {
                width: 30px;
            }
        }
    }
    .layout-box-text {
        position: relative;
        text-align: left;
        z-index: 1;
        padding-right: 10px;
        @media (max-width: 400px) {
            padding-right: 0px;
        }
        span {
            display: block;
            color: #000;
            font-weight: 600;
            font-size: 16px;
            line-height: 24px;
            margin-bottom: 5px;
            position: relative;
            @media (max-width: 400px) {
                font-size: 13px;
                line-height: 16px;
            }
        }

        span.subtext {
            color: #9b9b9b;
            font-size: 11px;
            line-height: 12px;
            /* padding-right: 12px; */
            /* background-image: url(../../images/double-arrow-right.svg); */
            background-size: 6px;
            background-repeat: no-repeat;
            background-position: right 55%;
            font-weight: normal;
        }
    }
    .mission {
        background-image: url(../../images/bg-mission.png);
        background-repeat: no-repeat;
        background-position: 5px center;
    }
`;
const StyledNews = styled.div<{ themeColor: string }>`
    height: 100vh;
    width: 100%;
    position: fixed;
    top: 0;
    left: 0;
    z-index: 99;
    display: flex;
    align-items: center;
    justify-content: center;
    max-width: 480px;
    background: rgba(0, 0, 0, 0.5);
    flex-direction: column;
    padding: 20px;
    .wrapper-popup-news {
        border-radius: 12px;
        overflow: hidden;
        position: relative;
        width: 100%;
        .control-popup-news {
            position: relative;
            display: block;
            z-index: 9;
        }
        .img-popup-news {
            height: 75dvh;
            position: relative;
            img {
                width: 100%;
                height: 100%;
                object-fit: cover;
            }
            /* &:after {
                content: "";
                z-index: 0;
                position: absolute;
                bottom: -5px;
                left: 0px;
                border-radius: 12px;
                width: calc(100% + 16px);
                height: calc(100% + 16px);
                background: rgb(0, 0, 0);
                background: linear-gradient(
                    0deg,
                    rgba(0, 0, 0, 0.7) 0%,
                    rgba(255, 255, 255, 0) 50%
                );
            } */
        }
        .slick-dots-bottom {
            width: 100%;
            display: flex !important;
            flex-direction: row;
            justify-content: space-between;
            top: 12px;
            padding: 0 16px;
            height: 20px;
            li {
                width: 100%;
                margin: 0;
                border-radius: 0;
                flex-grow: 1;
                height: 9px;
                margin-right: 2px;
                position: relative;
                button {
                    width: 100%;
                    background-color: #fff;
                }
            }
            li.slick-active {
                button {
                    background-color: #fff !important;
                }
            }
        }
        .popup-test {
            position: absolute;
            left: 12px;
            top: 50%;
        }
        .content-popup-news {
            position: absolute;
            left: 0;
            bottom: 0;
            padding: 32px 16px;
            h2 {
                font-size: 20px;
                line-height: 23px;
                margin-bottom: 8px;
                font-weight: 600;
                color: #fff;
            }
            .datetime-popup-news {
                background-image: url(../../images/ic-datetime.svg);
                background-position: left center;
                background-repeat: no-repeat;
                background-size: 10px;
                font-size: 10px;
                line-height: 13px;
                color: #c9c5bc;
                margin-bottom: 8px;
                padding-left: 16px;
            }
            p {
                font-size: 12px;
                line-height: 16px;
                color: #fff;
                display: -webkit-box;
                -webkit-box-orient: vertical;
                -webkit-line-clamp: inherit;
                overflow: hidden;
                p:last-child {
                    -webkit-line-clamp: 3;
                }
            }
            p.clicked {
                p:last-child {
                    -webkit-line-clamp: initial;
                }
            }
            .readmore {
                font-weight: 600;
                color: ${(p) => p.themeColor};
            }
        }
    }
    .close-popupinvite {
        position: relative;
        margin-top: 30px;
        z-index: 5;
        img {
            width: 32px;
        }
    }
`;

//#endregion
